module.exports = __webpack_public_path__ + "static/media/q4_2024.a2708732.png";